import React from "react";

/**
 * Reusable horizontal tab bar — same visual style as the Metrics page.
 *
 * Props:
 *   tabs        — array of { id, label, icon?, count? }
 *   activeTab   — currently active tab id
 *   onTabChange — (id) => void
 */
const Tabs = ({ tabs, activeTab, onTabChange }) => (
  <div className="border-b border-border mb-6">
    <nav className="flex gap-6">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onTabChange(tab.id)}
            className={`pb-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-2
              ${
                isActive
                  ? "border-foreground text-foreground"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`}
          >
            {Icon && <Icon className="h-4 w-4" />}
            {tab.label}
            {tab.count !== undefined && (
              <span
                className={`px-1.5 py-0.5 rounded-full text-xs font-medium
                  ${isActive ? "bg-foreground text-background" : "bg-muted text-muted-foreground"}`}
              >
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  </div>
);

export default Tabs;
